import { InputField } from '@components/form/input-field/InputField';
import { useTranslation } from 'react-i18next';

export const ResearchFormDisabledStoryLinkInput = () => {
  const { t } = useTranslation(['mailings']);

  return (
    <InputField
      disabled
      autoComplete="off"
      data-test="research-link-input"
      id="research-link-input"
      name="storyLink"
      placeholder={t(
        'mailings:personalizedMailingCreatorWizard.objectivesForm.research.researchLink.placeholder',
      )}
      size="l"
      value={''}
      onBlur={() => {
        return Promise.resolve();
      }}
      onChange={() => {
        return Promise.resolve();
      }}
    />
  );
};
